import { render, staticRenderFns } from "./DealerItem.vue?vue&type=template&id=09db7c6e&"
import script from "./DealerItem.vue?vue&type=script&lang=js&"
export * from "./DealerItem.vue?vue&type=script&lang=js&"
import style0 from "./DealerItem.vue?vue&type=style&index=0&id=09db7c6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports